module.exports = __webpack_public_path__ + "img/brand2.1746f21c.png";